import { render, staticRenderFns } from "./DialogCadastro.vue?vue&type=template&id=331580a9&scoped=true"
import script from "./DialogCadastro.vue?vue&type=script&lang=js"
export * from "./DialogCadastro.vue?vue&type=script&lang=js"
import style0 from "./DialogCadastro.vue?vue&type=style&index=0&id=331580a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331580a9",
  null
  
)

export default component.exports